import { useEffect, useState } from 'react';

import { mainStore } from '~/stores';

/**
 * Whether the app runs inside the native React Native WebView shell, safe for
 * use during render.
 *
 * `mainStore.isRN` is derived from `window.ReactNativeWebView`, which exists
 * only on the client. Reading it while rendering yields a different result than
 * SSR (where it is always `false`) and breaks hydration — the mismatch that
 * makes React discard the server tree. This hook returns the SSR value
 * (`false`) for the first client render, then the real value after mount, so
 * the initial client render stays identical to the server-rendered HTML.
 */
export const useIsRN = (): boolean => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted && mainStore.isRN;
};
